// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3475":"a46206ca","5437":"a46206ca","7068":"cccdaf71"}[chunkId] + ".chunk.css";
};